import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { cn } from '@epoch-ui/lib/utils';
import { SelectInput, SelectContent, SelectItem } from '@epoch-ui/components/Select';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage
} from '@epoch-ui/components/Form/form';

interface SelectFieldProps extends React.ComponentProps<typeof SelectInput> {
  name: string;
  label?: string | React.ReactNode;
  description?: string | React.ReactNode;
}

const SelectField = React.forwardRef<HTMLButtonElement, SelectFieldProps>(
  ({ name, label, description, className, placeholder, disabled, children }, ref) => {
    const formCtx = useFormContext();

    return (
      <FormField
        control={formCtx.control}
        name={name}
        render={({ field, fieldState }) => (
          <FormItem className={cn('tw-mt-4', className)}>
            {label && (
              <FormLabel className={cn('tw-mb-0', disabled && 'tw-opacity-40')}>{label}</FormLabel>
            )}
            {description && (
              <FormDescription className={cn('tw-m-0', disabled && 'tw-opacity-40')}>
                {description}
              </FormDescription>
            )}
            <FormControl>
              <SelectInput
                ref={ref}
                onValueChange={field.onChange}
                value={field.value}
                disabled={disabled}
                error={!!fieldState.error}
                placeholder={placeholder}
                className={'tw-mt-0'}
              >
                {children}
              </SelectInput>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );
  }
);

SelectField.displayName = 'SelectField';

export { SelectField, SelectItem as SelectFieldItem, SelectContent as SelectFieldContent };
